import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserXraySlider from 'src/games/XraySlider/Main';

interface XraySliderGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class XraySliderGame extends React.Component<XraySliderGameProps> {
    constructor(props: XraySliderGameProps) {
        super(props);
        bindAllOfThis(this, XraySliderGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserXraySlider onComplete={this.completeGame}/>
        </div>;
    }
}

export default XraySliderGame;



// WEBPACK FOOTER //
// ./src/pages/game/XraySliderGame.tsx